import { createDiscount } from "@redotech/redo-merchant-marketing-rpc/schema/discounts/create-discount";
import { deleteDiscount } from "@redotech/redo-merchant-marketing-rpc/schema/discounts/delete-discount";
import {
  getDiscountManagementDetail,
  paginateDiscountManagementDiscounts,
  paginateGeneratedDiscountCodes,
} from "@redotech/redo-merchant-marketing-rpc/schema/discounts/discount-management";
import { generatePreviewDiscountCode } from "@redotech/redo-merchant-marketing-rpc/schema/discounts/generate-preview-discount-code";
import { getDiscount } from "@redotech/redo-merchant-marketing-rpc/schema/discounts/get-discount";
import { getDiscountsByTeam } from "@redotech/redo-merchant-marketing-rpc/schema/discounts/get-discounts-by-team";
import { updateDiscount } from "@redotech/redo-merchant-marketing-rpc/schema/discounts/update-discount";
import type { InferRpcDefinition } from "@redotech/rpc/definition";

export const rpcDefinition = {
  createDiscount,
  deleteDiscount,
  generatePreviewDiscountCode,
  getDiscount,
  getDiscountManagementDetail,
  getDiscountsByTeam,
  paginateDiscountManagementDiscounts,
  paginateGeneratedDiscountCodes,
  updateDiscount,
};

export type RedoMerchantDiscountsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
